var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCerrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0526 11.9942L20.7726 4.2742C21.0626 3.9842 21.0626 3.5042 20.7726 3.2142C20.4826 2.9242 20.0026 2.9242 19.7126 3.2142L11.9926 10.9342L4.27262 3.2142C3.98262 2.9242 3.50262 2.9242 3.21262 3.2142C2.92262 3.5042 2.92262 3.9842 3.21262 4.2742L10.9326 11.9942L3.21262 19.7142C2.92262 20.0042 2.92262 20.4842 3.21262 20.7742C3.36262 20.9242 3.55262 20.9942 3.74262 20.9942C3.93262 20.9942 4.12262 20.9242 4.27262 20.7742L11.9926 13.0542L19.7126 20.7742C19.8626 20.9242 20.0526 20.9942 20.2426 20.9942C20.4326 20.9942 20.6226 20.9242 20.7726 20.7742C21.0626 20.4842 21.0626 20.0042 20.7726 19.7142L13.0526 11.9942Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrar);
export default __webpack_public_path__ + "static/media/cerrar.51a27543.svg";
export { ForwardRef as ReactComponent };